export default "__VITE_ASSET__e59a8b30__"